import React from "react";
import axios from "axios";
import { BACKEND_URL } from "../config/Constant";
import api from "../utils/axiosInstance";

const API = "support";


  export const createTicket = async (data) => {
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/addticket`, data);
      return response;
    } catch (error) {
      return error;
    }
  };

  export const getTickets = async () => {
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/gettickets`, null);
      return response;
    } catch (error) {
      return error;
    }
  };


  export const createChat = async (data) => {
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/addchat`, data);
      return response;
    } catch (error) {
      return error;
    }
  };


  export const getChats = async (data) => {
    const id={
      ticketId:data
    }
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/getchat`, id);
      return response;
    } catch (error) {
      return error;
    }
  };

  export const createSocket = async (data) => {
   
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/start-socket`, null);
      return response;
    } catch (error) {
      return error;
    }
  };




  





